var _path, _path2, _path3, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAlert = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9018 1.14837C36.7103 -0.382789 27.329 -0.382789 18.1375 1.14837C13.8858 1.85128 9.96087 3.86881 6.91372 6.91772C3.86657 9.96663 1.85021 13.8938 1.1477 18.148C-0.382568 27.3448 -0.382568 36.7315 1.1477 45.9283C1.8485 50.1831 3.86432 54.1112 6.91177 57.1605C9.95922 60.2097 13.8851 62.2267 18.1375 62.9279C22.7275 63.6651 27.3704 64.0233 32.0191 63.9988C36.6707 63.997 41.3142 63.6124 45.9028 62.8489C50.1544 62.1459 54.0794 60.1284 57.1265 57.0795C60.1737 54.0306 62.19 50.1034 62.8925 45.8493C63.6377 41.2706 64.0081 36.6386 63.9999 31.9996C63.9986 27.3457 63.6149 22.6999 62.8526 18.109C62.1472 13.8665 60.1342 9.95081 57.095 6.90956C54.0559 3.8683 50.1427 1.85363 45.9028 1.14737L45.9018 1.14837ZM55.0053 44.5773C54.5775 47.1865 53.3422 49.5957 51.4737 51.4654C49.6051 53.3351 47.1973 54.571 44.5896 54.999C40.434 55.6776 36.2296 56.0121 32.0191 55.999C27.8086 56.0121 23.6042 55.6776 19.4487 54.999C16.841 54.571 14.4332 53.3351 12.5646 51.4654C10.696 49.5957 9.46077 47.1865 9.03296 44.5773C7.64708 36.2522 7.64708 27.755 9.03296 19.4299C9.45924 16.8192 10.6938 14.4083 12.5625 12.537C14.4312 10.6658 16.8398 9.42871 19.4487 9.00017C27.769 7.6135 36.2612 7.6135 44.5816 9.00017C47.1907 9.42671 49.6003 10.662 51.4705 12.5318C53.3406 14.4016 54.577 16.8116 55.0053 19.4219C55.6835 23.5799 56.0177 27.7867 56.0047 31.9996C56.0178 36.2125 55.6835 40.4194 55.0053 44.5773V44.5773Z",
    fill: "url(#paint0_linear_2898_8401)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0226 15.9999C30.9624 15.9999 29.9456 16.4213 29.1959 17.1714C28.4462 17.9216 28.025 18.9389 28.025 19.9998V29.9995C28.025 31.0604 28.4462 32.0778 29.1959 32.8279C29.9456 33.578 30.9624 33.9994 32.0226 33.9994C33.0828 33.9994 34.0996 33.578 34.8493 32.8279C35.599 32.0778 36.0202 31.0604 36.0202 29.9995V19.9998C36.0202 18.9389 35.599 17.9216 34.8493 17.1714C34.0996 16.4213 33.0828 15.9999 32.0226 15.9999Z",
    fill: "url(#paint1_linear_2898_8401)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0202 43.999C36.0202 49.3309 28.025 49.3309 28.025 43.999C28.025 38.6672 36.0202 38.6672 36.0202 43.999Z",
    fill: "url(#paint2_linear_2898_8401)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2898_8401",
    x1: 56.512,
    y1: 8.96,
    x2: 8.896,
    y2: 58.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#5A49A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716146,
    stopColor: "#8A65EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2898_8401",
    x1: 35.0848,
    y1: 18.5198,
    x2: 24.8508,
    y2: 23.2672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#5A49A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716146,
    stopColor: "#8A65EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2898_8401",
    x1: 35.0848,
    y1: 41.1198,
    x2: 29.1343,
    y2: 47.3322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#5A49A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716146,
    stopColor: "#8A65EB"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlert, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Alert.ef58e686.svg";
export { ForwardRef as ReactComponent };